import api from './api';
import type { Goal, CreateGoalRequest, UpdateGoalRequest } from '../types';

export const goalService = {
  // 获取目标列表
  async getGoals(workspace: 'personal' | 'team' = 'personal', teamId?: string): Promise<Goal[]> {
    const params = new URLSearchParams();
    params.append('workspace', workspace);
    if (teamId) {
      params.append('teamId', teamId);
    }

    const response = await api.get(`/goals?${params.toString()}`);
    return response.data;
  },

  // 获取单个目标详情
  async getGoal(id: string): Promise<Goal> {
    const response = await api.get(`/goals/${id}`);
    return response.data;
  },

  // 创建目标
  async createGoal(data: CreateGoalRequest): Promise<Goal> {
    const response = await api.post('/goals', data);
    return response.data;
  },

  // 更新目标
  async updateGoal(id: string, data: UpdateGoalRequest): Promise<Goal> {
    const response = await api.patch(`/goals/${id}`, data);
    return response.data;
  },

  // 删除目标
  async deleteGoal(id: string): Promise<void> {
    await api.delete(`/goals/${id}`);
  },
};